import { React, useCallback, useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { DYNAMIC_TABLE, LIST, getApiPath } from '../../api/ApiConst';
import TableCreate from './TableCreate';
import TableFilter from '../constants/TableFilter';
import { useClient } from '../../config/ClientProvider';
import TableImport from './TableImport';

const TableList = () => {
	const { selectedClient } = useClient();
	const navigate = useNavigate();
	const [drawCount, setDrawCount] = useState(0);
	const [showAddModel, setShowAddModel] = useState(false);
	const [showImportModel, setShowImportModel] = useState(false);
	let rObj = {
		name: "",
		description: "",
		pathValue: "",
		addDefaultAttribute: false,
		isMultiTenantTable: false,
	};

	// Table Creation Model show/close
	const toggleAddModel = () => {
		setShowAddModel(prev => !prev);
	};

	// Table Import Model show/close
	const toggleImportModel = () => {
		setShowImportModel(prev => !prev);
	};

	// Create Table Record
	const handleCreateTableRecord = () => {
		toggleAddModel();
	};

	// Navigate to Table Records View

	// Refresh Table
	const refreshTableData = () => {
		setDrawCount((prev) => (prev + 1));
	};

	// get Table Records View
	const getTableView = useCallback(() => {
		return (
			<>
				{selectedClient ? (
					<div className="row justify-content-end">
						<div className="col-12 px-0">
							<div className="card">
								<div className="card-body d-flex justify-content-end" style={{ textAlign: "right" }}>
									<button className="btn btn-primary me-2" onClick={toggleImportModel}>
										Import
									</button>
									<button className="btn btn-primary" onClick={handleCreateTableRecord}>
										Create New
									</button>
								</div>
								<TableFilter
									tableName="table"
									tableUrl={getApiPath(DYNAMIC_TABLE, LIST)}
									paginationStatus={true}
									drawCount={drawCount}
									refreshTableData={refreshTableData}									
								/>
							</div>
						</div>
					</div>
				) : (
					<p>Please select a client to view data.</p>
				)}
			</>
		);
	}, [drawCount, selectedClient]);

	// useEffect to listen for selectedClient changes
	useEffect(() => {
		if (selectedClient) {
			// Any logic to re-fetch data or trigger updates when selectedClient changes
			refreshTableData();
		}
	}, [selectedClient]);

	return (
		<>
			{getTableView()}
			<TableCreate
				show={showAddModel}
				close={toggleAddModel}
				successCallBack={refreshTableData}
				object={rObj}
			/>
			<TableImport
				show={showImportModel}
				close={toggleImportModel}
				successCallBack={refreshTableData}
			/>
		</>
	);
};

export default TableList;
